import React from 'react';
import { MainLayout, InnerLayout } from '../styles/Layouts';
import { Title } from '../Components/Ui/Title';
import portfolios from '../data/portfolios';
import { PortfolioSection } from '../Components/Portfolio/PortfolioSection';

export const Portfolio = () => {
  return (
    <MainLayout>
      <Title title={'Portfolio'} span={'Portfolio'} />
      <InnerLayout>
        <PortfolioSection portfolios={portfolios} />
      </InnerLayout>
    </MainLayout>
  );
};
